import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import { AppProvider } from '@/app/AppProvider';
import { App } from '@/app/App';
import { initializeGoogleAds } from '@/ads';
import './styles.css';

document.getElementById('seo-fallback')?.remove();
initializeGoogleAds();

createRoot(document.getElementById('app')!).render(
  <StrictMode>
    <BrowserRouter>
      <AppProvider>
        <App />
      </AppProvider>
    </BrowserRouter>
  </StrictMode>,
);
